
import '@/mixins/extendedComponent'
import { localforage } from '@/utils/storage'

export default {

  created () {
    window.addEventListener('resize', this._onResize)
    window.addEventListener('scroll', this._onScroll)
    window.addEventListener('keydown', this._onKeyDown)
    
    this._onResize()

    const keydownHandler = (e) => {
      // for old browser support as a fallback
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.onEscapePress()
      }
    }
    document.addEventListener('keydown', keydownHandler)

    this.setLang(this.$route)
    this.forceLang()
  },

  methods: {
    _onResize (event) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$device._onResize()
        this.$hub.emit('resize', event)
      }, 200)
    },
    _onScroll (event) {
      this.$device._onScroll()
      this.$hub.emit('scroll', event)
    },
    _onKeyDown (event) {
      this.$hub.emit('keydown', event.keyCode)
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        this.$hub.emit('keydown:escape', event.keyCode)
      }
    },
    setLang (to) {
      if (to.meta.locale !== this.$i18n.locale) {
        this.$i18n.locale = to.meta.locale
      }
    },
    forceLang () {
      localforage.getItem('language').then( (res) => {
        if (res === null) {
          localforage.setItem('language', true)

          let lang = ''
          console.log(navigator.languages[0])
          if ( navigator.languages[0].includes('fr') ) {
            this.$i18n.locale = 'fr'
            this.$router.push(this.$local.getRoute('homepage'))
          }
        }
      })
    }
  },

  watch: {
    $route (to, from) {
      setTimeout( () => { window.scrollTo(0, 0) }, 500)
      this.setLang(to)
    }
  }
}
